import { pdf } from "@react-pdf/renderer";
import React from "react";
import { ISignForm } from "../interfaces/ISignForm";
import { SignOrderPDF } from "../components/order/SignOrderPDF";
import { saveAs } from "file-saver";

export const downloadPDF = async (
  order: ISignForm,
  previewImage: string,
  logo: string,
  isBlob?: boolean
) => {
  const blob = await pdf(
    <SignOrderPDF order={order} sign={previewImage} logo={logo} />
  ).toBlob();
  if (isBlob) {
    return blob;
  }
  saveAs(blob, "ATA_orderbekräftelse.pdf");
};
